import ComponentCard from "../../components/common/ComponentCard";
import ListComponent from "../../components/common/ListComponent";
import React from "react";
import PageMeta from "../../components/common/PageMeta";

const LearningList = () => {
    return (
        <>
            <PageMeta title="Danh sách bài viết" description="Trang danh sách bài viết"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <ListComponent type="6" router="learning" />
                </ComponentCard>
            </div>
        </>
    );
};

export default LearningList;